/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { ComponentChildren, ComponentChild, toChildArray, isValidElement, Fragment } from 'preact';
import { ButtonSetPositionContext } from '../hooks/UNSAFE_useButtonSetPositionContext';
import { indexToPosition } from '../utils/UNSAFE_buttonUtils';

type ButtonSetItemsProps = {
  /**
   * The children are an array of buttonsetitems
   */
  children: ComponentChildren;
};

/**
 * ButtonSetItems renders the ButtonSet children
 */
export function ButtonSetItems({ children }: ButtonSetItemsProps) {
  const childrenArray: ComponentChild[] = toChildArray(children);

  return (
    <Fragment>
      {childrenArray.map((value, index) => {
        if (!isValidElement(value)) return null;
        else
          return (
            <ButtonSetPositionContext.Provider
              value={{
                position: indexToPosition(index, childrenArray.length)
              }}>
              {value}
            </ButtonSetPositionContext.Provider>
          );
      })}
    </Fragment>
  );
}

ButtonSetItems.displayName = 'ButtonSetItems';
